import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card, Alert, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Title, Text } = Typography;

const ForgotPasswordPage = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [errorAlert, setErrorAlert] = useState({ visible: false, message: '' });
  const [successAlert, setSuccessAlert] = useState({ visible: false, message: '' });

  const handleForgotPassword = async (values) => {
    setErrorAlert({ visible: false, message: '' });
    setSuccessAlert({ visible: false, message: '' });
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/user/password`,
        { email: values.email }
      );
      if (response.status === 200) {
        setSuccessAlert({
          visible: true,
          message: 'Password reset email sent! Please check your inbox.',
        });
        message.success('Check your inbox for instructions!');
      }
    } catch (error) {
      setErrorAlert({
        visible: true,
        message: error.response?.data?.reason ?? 'Failed to send password reset email.',
      });
    }
  };

  const handleBackToLogin = () => {
    navigate('/ui/login');
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f6f6f6' }}>
      <Card style={{ width: 650, padding: '40px 40px 32px 40px' }}>
        <Title level={2}>Forgot Password?</Title>
        <Text>Enter your email address and we will send you instructions to reset your password.</Text>

        {successAlert.visible && (
          <Alert style={{ marginTop: 16, marginBottom: 16 }} message={successAlert.message} type="success" closable onClose={() => setSuccessAlert({ ...successAlert, visible: false })} />
        )}

        {errorAlert.visible && (
          <Alert style={{ marginTop: 16, marginBottom: 16 }} message={errorAlert.message} type="error" closable onClose={() => setErrorAlert({ ...errorAlert, visible: false })} />
        )}

        <Form form={form} name="forgot-password" layout="vertical" onFinish={handleForgotPassword}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter your email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Send Reset Instructions
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" block onClick={handleBackToLogin}>
              Back to Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
